import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";
const principle: LayoutComponent = {
  variant: "layout",
  data: {
    type: "custom031700",
    options: {
      data: {
        is: {
          mainImageUrl: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-1-1.svg`,
          graph1Url: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-1-2.svg`,
          graph2Url: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-1-3.svg`,
          sounds: {
            0: `${config.ASSETS_URL}/03/17/principle/concert-hall/music_RIR_IS.wav.mp3`,
            1: `${config.ASSETS_URL}/03/17/principle/concert-hall/speech_RIR_IS.wav.mp3`,
            2: `${config.ASSETS_URL}/03/17/principle/concert-hall/music_BRIR_IS.wav.mp3`,
            3: `${config.ASSETS_URL}/03/17/principle/concert-hall/speech_BRIR_IS.wav.mp3`,
          },
        },
        rt: {
          mainImageUrl: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-1-1.svg`,
          graph1Url: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-2-2.svg`,
          graph2Url: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-2-3.svg`,
          sounds: {
            0: `${config.ASSETS_URL}/03/17/principle/concert-hall/music_RIR_RT.wav.mp3`,
            1: `${config.ASSETS_URL}/03/17/principle/concert-hall/speech_RIR_RT.wav.mp3`,
            2: `${config.ASSETS_URL}/03/17/principle/concert-hall/music_BRIR_RT.wav.mp3`,
            3: `${config.ASSETS_URL}/03/17/principle/concert-hall/speech_BRIR_RT.wav.mp3`,
          },
        },
        rt_is: {
          mainImageUrl: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-1-1.svg`,
          graph1Url: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-3-2.svg`,
          graph2Url: `${config.ASSETS_URL}/03/17/principle/concert-hall/figure-3-3.svg`,
          sounds: {
            0: `${config.ASSETS_URL}/03/17/principle/concert-hall/music_RIR_Combined.wav.mp3`,
            1: `${config.ASSETS_URL}/03/17/principle/concert-hall/speech_RIR_Combined.wav.mp3`,
            2: `${config.ASSETS_URL}/03/17/principle/concert-hall/music_BRIR_Combined.wav.mp3`,
            3: `${config.ASSETS_URL}/03/17/principle/concert-hall/speech_BRIR_Combined.wav.mp3`,
          },
        },
      },
    },
  },
};

export default principle;
